import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var EyeOutline = function EyeOutline(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1.03125 * size,
    height: size,
    viewBox: "0 0 33 32",
    children: [/*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M16.682 26.367c-5.495 0-10.887-3.060-16.021-9.098-0.399-0.468-0.433-1.145-0.086-1.651 0.28-0.409 6.945-9.983 16.301-9.983 5.543 0 10.743 3.352 15.451 9.962 0.329 0.464 0.337 1.081 0.022 1.55-0.254 0.376-6.302 9.22-15.666 9.22zM3.453 16.324c4.364 4.856 8.812 7.318 13.229 7.318 6.436 0 11.25-5.273 12.839-7.267-3.999-5.32-8.249-8.018-12.648-8.018-6.438 0.001-11.666 5.772-13.421 7.967z"
    }), /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M16.457 9.444c-3.622 0-6.557 2.936-6.557 6.557s2.935 6.557 6.557 6.557c3.621 0 6.556-2.938 6.556-6.557 0-3.622-2.935-6.557-6.556-6.557zM18.805 16.098c-1.459 0-2.643-1.184-2.643-2.641 0-1.461 1.184-2.644 2.643-2.644s2.641 1.182 2.641 2.644c0.001 1.458-1.182 2.641-2.641 2.641z"
    })]
  });
};
export default EyeOutline;